import { render } from "./TooltipComponent.vue?vue&type=template&id=3a6ffb4b&ts=true"
import script from "./TooltipComponent.vue?vue&type=script&lang=ts"
export * from "./TooltipComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__